import { BiMenu } from "react-icons/bi";
import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import { useDrawer } from "../../contexts/drawerContext";
import { useTranslation } from "react-i18next";
import IconWrapper from "../Common/IconWrapper";

const MenuIcon = IconWrapper(BiMenu);

/**
 * `HamburgerMenu` renders an icon button (hamburger menu) that opens the global navigation drawer.
 *
 * Features:
 * - Positioned in the top-right corner of the app
 * - Displays a tooltip on hover ("Menu")
 * - Enlarged icon size for better tap/click target
 * - Uses shared `drawerContext` to trigger `MenuDrawer`
 *
 * Intended usage:
 * Place this component inside a page layout or root `App.tsx` for global navigation access.
 *
 * @component
 * @example
 * ```tsx
 * <HamburgerMenu />
 * ```
 */
const HamburgerMenu = () => {
    const theme = useTheme();
    const { t } = useTranslation("translation", { keyPrefix: "menu" });
    const { openDrawer } = useDrawer();

    return (
        <Box
            sx={{
                position: "fixed",
                top: 16,
                right: 16,
                display: "flex",
                gap: 1,
                zIndex: theme => theme.zIndex.drawer - 1
            }}
        >
            <Tooltip title={t("menu")} placement="top">
                <IconButton onClick={openDrawer} sx={{ padding: "8px" }}>
                    <MenuIcon style={{ width: 32, height: 32, color: theme.palette.primaryIcon }} />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default HamburgerMenu;
